@if (metricValues()) {
    <table>
        <thead>
            <tr>
                <th class="col-head"></th>
                @for (col of settings().cols; track col) {
                    <th class="col-head">{{ col.label }}</th>
                }
            </tr>
        </thead>
        <tbody>
            @for (row of settings().rows; track row) {
                <tr>
                    <th class="row-head">{{ row.label }}</th>
                    @for (col of settings().cols; track col) {
                        <td>
                            <span>{{ formatCellValue(col.name, row) }}</span>
                        </td>
                    }
                </tr>
            }
        </tbody>
    </table>
}
